import React, { useEffect, useState } from "react";
import { adminApi } from "../adminApi";

const tableCard = { background: "white", borderRadius: 12, border: "1px solid #E5E7EB", overflow: "hidden" };
const td = { padding: "10px 14px", fontSize: 12.5, color: "#0F1B2D", borderTop: "1px solid #F1F5F9" };
const th = { padding: "10px 14px", fontSize: 11, color: "#6B7280", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1px solid #E5E7EB", fontWeight: 700 };
const input = { height: 32, padding: "0 8px", border: "1px solid #D1D5DB", borderRadius: 6, fontSize: 12.5 };
const btn = { background: "#1E3A5F", color: "white", border: "none", borderRadius: 6, padding: "7px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer" };

const TYPES = ["checklist", "template", "guide", "article", "tool", "external"];

export default function ExpertAdminResources() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ title: "", description: "", resource_type: "guide", url: "", category: "" });
  const [migrationRequired, setMigrationRequired] = useState(false);

  const load = async () => {
    const res = await adminApi.expertListResources();
    if (res.ok) { setRows(res.data.resources || []); setMigrationRequired(!!res.data.migration_required); }
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.title.trim() || !form.url.trim()) return;
    const res = await adminApi.expertCreateResource(form);
    if (res.ok) { setForm({ title: "", description: "", resource_type: "guide", url: "", category: "" }); load(); }
  };
  const toggleActive = async (r) => { await adminApi.expertPatchResource(r.id, { is_active: !r.is_active }); load(); };
  const remove = async (id) => { if (window.confirm("Delete this resource?")) { await adminApi.expertDeleteResource(id); load(); } };

  if (migrationRequired) {
    return <div style={{ ...tableCard, padding: 16, color: "#B45309", fontSize: 13 }}>
      C-ORE Expert tables aren't migrated yet — run backend/migrations/2026-08_core_expert.sql in Supabase.
    </div>;
  }

  return (
    <div data-testid="expert-admin-resources">
      <div style={{ ...tableCard, padding: 14, marginBottom: 14, display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input data-testid="resource-form-title" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} style={input} />
        <input data-testid="resource-form-description" placeholder="Short description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} style={{ ...input, width: 200 }} />
        <select data-testid="resource-form-type" value={form.resource_type} onChange={(e) => setForm({ ...form, resource_type: e.target.value })} style={input}>
          {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
        <input data-testid="resource-form-url" placeholder="URL" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} style={{ ...input, width: 220 }} />
        <input data-testid="resource-form-category" placeholder="Category (optional)" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} style={input} />
        <button data-testid="resource-form-add-btn" onClick={add} style={btn}>Add Resource</button>
      </div>
      <div style={tableCard}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr><th style={th}>Title</th><th style={th}>Type</th><th style={th}>Category</th><th style={th}>Status</th><th style={th}></th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td style={td} colSpan={5}>No resources yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`resource-row-${r.id}`}>
                <td style={td}><a href={r.url} target="_blank" rel="noreferrer">{r.title}</a><div style={{ color: "#6B7280" }}>{r.description}</div></td>
                <td style={td}>{r.resource_type}</td>
                <td style={td}>{r.category || "—"}</td>
                <td style={td}>{r.is_active ? <span style={{ color: "#047857" }}>Active</span> : <span style={{ color: "#6B7280" }}>Inactive</span>}</td>
                <td style={{ ...td, textAlign: "right" }}>
                  <button data-testid={`resource-toggle-${r.id}`} onClick={() => toggleActive(r)} style={{ ...btn, background: "white", color: "#1E3A5F", border: "1px solid #1E3A5F", marginRight: 6 }}>
                    {r.is_active ? "Deactivate" : "Activate"}
                  </button>
                  <button data-testid={`resource-delete-${r.id}`} onClick={() => remove(r.id)} style={{ ...btn, background: "white", color: "#DC2626", border: "1px solid #DC2626" }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
